import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "how page" }
const _hoisted_2 = { class: "hiw-wrap" }
const _hoisted_3 = { class: "overview-row" }
const _hoisted_4 = { class: "tldr casino-card" }
const _hoisted_5 = { class: "tldr-steps" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "diagram-card" }
const _hoisted_9 = { class: "diagram-version mono" }
const _hoisted_10 = {
  class: "scenario-tabs",
  role: "tablist",
  "aria-label": "Scenario"
}
const _hoisted_11 = ["aria-selected", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "pp"
}
const _hoisted_13 = { class: "pp-cols" }
const _hoisted_14 = { class: "pp-col" }
const _hoisted_15 = { class: "pp-meta" }
const _hoisted_16 = { class: "pp-meta" }
const _hoisted_17 = { class: "pp-trigger" }
const _hoisted_18 = { class: "pp-out-title" }
const _hoisted_19 = { class: "pp-out-detail" }
const _hoisted_20 = {
  key: 1,
  class: "pp"
}
const _hoisted_21 = { class: "pp-cols" }
const _hoisted_22 = { class: "pp-col" }
const _hoisted_23 = { class: "pp-meta" }
const _hoisted_24 = { class: "pp-meta" }
const _hoisted_25 = { class: "pp-trigger" }
const _hoisted_26 = {
  key: 0,
  class: "pp-trigger-sub mono"
}
const _hoisted_27 = { class: "pp-out-title" }
const _hoisted_28 = { class: "pp-out-detail" }
const _hoisted_29 = {
  key: 2,
  class: "pp"
}
const _hoisted_30 = { class: "pp-cols" }
const _hoisted_31 = { class: "pp-col" }
const _hoisted_32 = { class: "pp-box you" }
const _hoisted_33 = { class: "pp-meta" }
const _hoisted_34 = { class: "pp-col" }
const _hoisted_35 = { class: "pp-meta" }
const _hoisted_36 = { class: "pp-meta" }
const _hoisted_37 = { class: "pp-trigger" }
const _hoisted_38 = {
  key: 0,
  class: "pp-trigger-sub mono"
}
const _hoisted_39 = { class: "pp-out-title" }
const _hoisted_40 = { class: "pp-out-detail" }
const _hoisted_41 = {
  key: 3,
  class: "scenario-note"
}
const _hoisted_42 = {
  key: 4,
  class: "scenario-note"
}
const _hoisted_43 = {
  key: 5,
  class: "scenario-warn"
}
const _hoisted_44 = { class: "hiw-section" }
const _hoisted_45 = { class: "section-intro" }
const _hoisted_46 = {
  class: "variant-tabs evolution-tabs",
  role: "tablist",
  "aria-label": "Design evolution"
}
const _hoisted_47 = ["aria-selected", "onClick"]
const _hoisted_48 = { class: "evolution-card casino-card" }
const _hoisted_49 = { class: "evolution-headline" }
const _hoisted_50 = { class: "evolution-version mono" }
const _hoisted_51 = { class: "evolution-title" }
const _hoisted_52 = { class: "evolution-summary" }
const _hoisted_53 = { class: "evolution-grid" }
const _hoisted_54 = { class: "evolution-pane" }
const _hoisted_55 = { class: "evolution-pane" }
const _hoisted_56 = { class: "evolution-h" }
const _hoisted_57 = { class: "hiw-section" }
const _hoisted_58 = { class: "subscript" }
const _hoisted_59 = {
  key: 0,
  class: "sub-body"
}
const _hoisted_60 = { class: "leaf-cols" }
const _hoisted_61 = { class: "leaf-col" }
const _hoisted_62 = { class: "leaf-kind mono" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 0,
  class: "script-detail"
}
const _hoisted_65 = { class: "leaf-col" }
const _hoisted_66 = { class: "leaf-kind mono" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 0,
  class: "script-detail"
}
const _hoisted_69 = { class: "hiw-section" }
const _hoisted_70 = { class: "flow-version mono" }
const _hoisted_71 = { class: "flow" }
const _hoisted_72 = { class: "flow-num" }
const _hoisted_73 = { class: "flow-body" }
const _hoisted_74 = ["innerHTML"]
const _hoisted_75 = { class: "hiw-footer" }

import { ref, computed, onMounted } from 'vue'
import StepList from '@/components/StepList.vue'
import { getNetwork } from '@/services/api'

// Expand state, keyed by leaf name (+ 'cond' for the shared win-condition).
type Evolution = 'v1' | 'v2' | 'v3' | 'v4'
interface EvolutionCard {
  version: string
  title: string
  badge: { label: string; cls: string }
  summary: string
  how: string[]
  why: string[]
  /** Header for the right pane — defaults to "Why we moved on"; the newest
   *  variant overrides it (nothing's superseded it yet). */
  whyTitle?: string
}
interface FlowStep { num: string; title: string; body: string; cls?: string }
type Scenario = 'happy' | 'nofund' | 'noreveal'
interface Step { ops: string[]; explain: string }

// ── Byte-accurate opcodes, disassembled from the real CoinflipEscrowScript
//    (packages/lib), grouped into steps with plain-language explanations. ──

// Coin win-determination condition (buildCoinflipConditionScript).
// Variable-odds condition (buildVariableOddsConditionScript), shown for n=6, lo=0, target=3.
const VERIFY = 'OP_VERIFY'

// Reusable step fragments.
interface Leaf {
  key: string; name: string; group: 'collab' | 'exit'; cls: string
  kind: string; desc: string; steps: Step[]; payout?: 'player' | 'house'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HowItWorksView',
  setup(__props) {

const open = ref<Record<string, boolean>>({})
const toggle = (k: string) => { open.value = { ...open.value, [k]: !open.value[k] } }

// ── Design evolution tabs ─────────────────────────────────────────
//
// Each design is a real shipped variant of the coinflip contract. The
// tabs let a reader see WHY the protocol changed shape between versions
// — the failure modes that motivated v2, and the script-cleanups that
// motivated v3. v0.3 is the design every other section on this page
// describes in detail.
const EVOLUTION: { id: Evolution; tab: string }[] = [
  { id: 'v1', tab: 'v0.1 — setup/final (original)' },
  { id: 'v2', tab: 'v0.2 — per-party covenant' },
  { id: 'v3', tab: 'v0.3 — Arkade-Script + packets ★' },
  { id: 'v4', tab: 'v0.4 — joint pot (opt-in)' },
]
const EVOLUTION_BY: Record<Evolution, EvolutionCard> = {
  v1: {
    version: 'v0.1',
    title: 'Setup + final, shared escrow',
    badge: { label: 'retired', cls: 'badge-old' },
    summary:
      "Two transactions per game (setup + final), with a single shared escrow funded by both sides. The earliest design — it shipped, but it had abort-theft windows that the per-party design closes.",
    how: [
      "A 'setup' tx put both stakes into one shared escrow address.",
      "A 'final' tx redistributed the pot on reveal — pay-out covenant referenced the committed hashes.",
      "Settlement and refund both touched the SHARED escrow; either side could grief the other on stall.",
    ],
    why: [
      "Abort theft: if one side never funded, the other side's funds could be stranded with no clean self-refund path.",
      "Multi-tx setup added latency and broke gracefully only on the happy path — recovery flows were complex.",
      "Single escrow meant a server stall could leave BOTH stakes in limbo; the reveal-then-stall window paid the staller.",
    ],
  },
  v2: {
    version: 'v0.2',
    title: 'Per-party escrow, length-encoded predicate',
    badge: { label: 'previous default', cls: 'badge-prev' },
    summary:
      "Each side funds its OWN escrow into a 4-leaf Taproot tree (covenant + forfeit + refund + exit), so a no-show can NEVER touch the other side's stake. Win condition lives in Bitcoin Script and hides the random digit in the secret's BYTE LENGTH.",
    how: [
      'Per-funder escrow: 4 collaborative leaves (`*winCovenant`, `playerForfeit`, `refund`) + 4 CSV-gated unilateral-exit mirrors.',
      'Win condition: `OP_SIZE` on each revealed secret → secret length encodes a digit; (digitC + digitP) mod n decides the winner.',
      'Atomic-sweep covenant pays the full pot on-chain — winner signs nothing, loser has no spend path.',
    ],
    why: [
      'The length-encoded digit is fragile to extend (every new odds variant adds opcodes) and burns extra bytes per secret.',
      "Secrets are arbitrary bytes — there's no canonical wire shape for higher-level tooling to share between server and client.",
      'The on-chain script is harder to audit than `OP_INSPECTPACKET`-based reveals where the emulator runs the decision in arkade-script.',
    ],
  },
  v3: {
    version: 'v0.3',
    title: 'Arkade-Script win condition + packet-borne reveals',
    badge: { label: 'shipping now', cls: 'badge-new' },
    summary:
      "Per-party escrow keeps its safety guarantees, but the win-condition predicate MOVES INTO arkade-script. Reveals are typed extension packets attached to the spending tx (`OP_INSPECTPACKET`) — not raw bytes whose length encodes meaning. Cleaner consensus check, simpler client, 10-leaf taptree.",
    how: [
      'Each side commits a `digit + salt` ; the on-chain `digitHash = SHA256([digit] ‖ salt)` is verified by the emulator at sweep time.',
      'Reveals ride two extension packets (0x10 = player, 0x11 = creator); the win-predicate reads them via `OP_INSPECTPACKET`, runs `(dC+dP) mod n` in arkade-script.',
      'The escrow taptree gains a cooperative `playerSpend` leaf and a CSV mirror — 10 leaves total. The taptree is assembled with btcd\'s algorithm so arkd and the SDK agree on the tap-key.',
    ],
    why: [
      'Why this is the keeper: emulator-evaluated predicate makes the win condition trivial to extend (new game shapes are arkade-script edits, no tapscript rework).',
      'Typed packets give the client a fixed-length wire shape and remove the secret-length-as-data trick.',
      'The btcd-compatible taptree fix has been upstreamed into the official @arkade-os/ts-sdk so every consumer of the SDK gets correct tap-keys for any leaf count.',
    ],
  },
  v4: {
    version: 'v0.4',
    title: 'Joint pot — atomic co-fund, 2 on-chain txs',
    badge: { label: 'current', cls: 'badge-prev' },
    summary:
      "Collapses the two per-party escrows into ONE joint-pot VTXO funded by a single atomic two-party co-fund, then settled by paying the whole pot to the winner — 2 on-chain txs (co-fund + settle) instead of v0.3's three, with the same commit–reveal fairness and emulator covenant. This is the only version the client, house server, and library run: the legacy v0.2/v0.3 per-party escrow paths have been removed.",
    how: [
      'One co-fund tx spends BOTH stake VTXOs (player + house) into a single joint pot — a 2-round signing handshake the API orchestrates, where each party signs only its OWN input + checkpoint (proven feasible on regtest; v0.3 deliberately avoided this).',
      'The pot is an 8-leaf taptree whose win leaves pay the WHOLE pot to the winner via `payTo(winner, pot)` on the one VTXO — vs v0.3\'s two-escrow `atomicSweep`. Same arkade-script win-predicate + `OP_INSPECTPACKET` reveals.',
      'Settle is one input → one output: the winner\'s win-covenant leaf + the emulator, off a single player reveal. The /api/v4 endpoints (play → cofund → cofund-finalize → reveal) drive the whole flow.',
    ],
    whyTitle: 'What it improves',
    why: [
      'Fewer on-chain txs (2 vs 3) and fewer round-trips → faster settlement and lower fees.',
      'One joint pot, not two escrows: the winner sweeps a single VTXO, and the API funnels every arkd submit — which sidesteps a checkpoint-signature race we found under concurrent load.',
      'A pre-signed cooperative refund plus CSV unilateral-exit mirrors keep it non-custodial; the house stays a counterparty (not a permissionless taker).',
    ],
  },
}
const evolution = ref<Evolution>('v4')

// Reflect the protocol version the server actually serves (from /api/network):
// open the page on that version and tailor the "what this client plays" copy.
// The client is v0.4-only now, so v4 is the default; fall back to it if the
// network can't be reached.
const activeVersion = ref<'v3' | 'v4'>('v4')
onMounted(async () => {
  try {
    const net = await getNetwork()
    activeVersion.value = net.protocolVersion === 'v4' ? 'v4' : 'v3'
    evolution.value = activeVersion.value
  } catch {
    /* keep the v0.4 default */
  }
})

// Per-version game flow. v0.1 (shared escrow) had setup + final txs; v0.2 and
// v0.3 share the per-party shape, but v0.3 specifically routes reveals through
// extension packets read on-chain via OP_INSPECTPACKET.
const FLOW_STEPS: Record<Evolution, FlowStep[]> = {
  v1: [
    { num: '1', title: 'Play & commit', body: 'You commit your secret\'s hash; the house commits its own. The contract address is derived from both commitments.' },
    { num: '2', title: 'Setup tx', body: 'Both sides co-sign a <em>single</em> setup transaction that funds <strong>one shared escrow</strong> with the combined pot.' },
    { num: '3', title: 'Reveal', body: 'You send your secret to the server. Combined with the house secret, it decides the winner via the length-encoded coin scheme.' },
    { num: '4', title: 'Final tx', body: 'A pre-agreed final transaction redistributes the shared pot to the winner. Both sides must co-sign — anyone who stalls grids the funds.' },
    { num: '!', title: 'If the operator goes dark', body: 'The big v0.1 weakness: a no-show on the setup tx leaves your half-stake stranded, and a stall after the reveal needs both sides\' signatures on the final tx to recover.', cls: 'recovery' },
  ],
  v2: [
    { num: '1', title: 'Play & commit', body: 'You commit your secret\'s hash; the house commits its own. The server returns a <strong>per-party</strong> escrow address derived from both commitments.' },
    { num: '2', title: 'Escrow the stakes', body: 'You fund the <em>player escrow</em>, the house funds the <em>house escrow</em> — two single-party transactions into separate contracts that neither side can touch alone.' },
    { num: '3', title: 'Reveal', body: 'You send your secret bytes to the server. Combined with the house secret, the length-encoded mod-n rule deterministically decides the winner.' },
    { num: '4', title: 'Covenant settlement', body: 'The server builds one atomic sweep of <em>both</em> escrows to the winner\'s address. The emulator runs the arkade-script atomic-sweep covenant, confirms the payout matches, co-signs the <span class="mono">&lt;emu✦&gt;</span> slot, and forwards it on. <strong>The winner signs nothing.</strong>' },
    { num: '!', title: 'If the operator goes dark', body: 'Revealed but unpaid? Sweep the whole pot via <span class="mono">playerForfeit</span> after the deadline. Never revealed? <span class="mono">refund</span>. Operator censoring? Take a unilateral <span class="mono">*Exit</span> after the CSV delay.', cls: 'recovery' },
  ],
  v3: [
    { num: '1', title: 'Play & commit', body: 'You commit a <strong>digit + 16-byte salt</strong> (the digit picks your coin face for n=2; the salt blinds it). Only <span class="mono">SHA256(digit‖salt)</span> goes on-chain — your digit is hidden until reveal.' },
    { num: '2', title: 'Escrow the stakes', body: 'You fund the <em>player escrow</em>, the house funds the <em>house escrow</em> — two single-party transactions into the v3 10-leaf taptree. Neither side can touch the other\'s stake.' },
    { num: '3', title: 'Reveal (via extension packet)', body: 'You send <span class="mono">[digit] ‖ salt</span> to the server. The server attaches BOTH reveals as <strong>typed extension packets</strong> (0x10 player, 0x11 creator) to the sweep tx — the emulator reads them on-chain via <span class="mono">OP_INSPECTPACKET</span>.' },
    { num: '4', title: 'Arkade-script settlement', body: 'The emulator runs the <em>win predicate</em>: pulls both reveal packets, verifies their hashes, extracts the digits, and decides via <span class="mono">(dC + dP) mod n ∈ [lo, target)</span>. If the predicate passes, the atomic-sweep covenant pays the full pot to the winner. <strong>The winner signs nothing.</strong>' },
    { num: '!', title: 'If the operator goes dark', body: 'Same three recovery leaves as v0.2 — <span class="mono">playerForfeit</span> (post-reveal stall), <span class="mono">refund</span> (pre-reveal stall), and <span class="mono">*Exit</span> mirrors (operator censoring). v0.3 also adds a <span class="mono">cooperativeSpend</span> leaf so player + creator can settle without the emulator if it disappears.', cls: 'recovery' },
  ],
  v4: [
    { num: '1', title: 'Play & commit', body: 'You commit a <strong>digit + 16-byte salt</strong> (the digit picks your coin face for n=2; the salt blinds it). Only <span class="mono">SHA256(digit‖salt)</span> goes on-chain. The server returns the <strong>joint-pot</strong> covenant params — one pot address, not two per-party escrows.' },
    { num: '2', title: 'Co-fund the pot', body: 'A <strong>single atomic transaction</strong> spends BOTH stake VTXOs — yours and the house\'s — into <em>one joint-pot VTXO</em>. A 2-round signing handshake the API orchestrates, where each side signs only its OWN input, so neither can move the pot alone.' },
    { num: '3', title: 'Reveal (via extension packet)', body: 'You send <span class="mono">[digit] ‖ salt</span> to the server. Both reveals ride the settle tx as <strong>typed extension packets</strong> the emulator reads on-chain via <span class="mono">OP_INSPECTPACKET</span> — same commit–reveal fairness as v0.3.' },
    { num: '4', title: 'Covenant settlement', body: 'The emulator runs the <em>win predicate</em> on the 8-leaf pot, verifies both reveal hashes, and decides via <span class="mono">(dC + dP) mod n ∈ [lo, target)</span>. A win leaf pays the <strong>whole pot</strong> to the winner via <span class="mono">payTo(winner, pot)</span> — 2 on-chain txs (co-fund + settle) instead of v0.3\'s three. <strong>The winner signs nothing.</strong>' },
    { num: '!', title: 'If the operator goes dark', body: 'A pre-signed <span class="mono">cooperativeSpend</span>, a CLTV <span class="mono">refund</span> (pre-reveal stall), and a staged <span class="mono">playerForfeit</span> → <span class="mono">StageTwo</span> take-all (post-reveal stall, after the CSV delay) keep it non-custodial — the house stays a counterparty, never a permissionless taker.', cls: 'recovery' },
  ],
}

// ── At-a-glance scenario toggle ───────────────────────────────────
// The per-party escrow means each failure mode has a self-serve mitigation.
const scenarios: { id: Scenario; label: string }[] = [
  { id: 'happy', label: 'Happy path' },
  { id: 'nofund', label: "House doesn't fund" },
  { id: 'noreveal', label: 'Secret not revealed' },
]
const scenario = ref<Scenario>('happy')
const OUTCOMES: Record<Scenario, { kind: string; trigger: string; title: string; detail: string; note: string }> = {
  happy: {
    kind: 'win', trigger: 'you reveal → covenant settles',
    title: 'Winner takes the pot', detail: 'covenant pays the full pot on-chain',
    note: 'Both stakes are escrowed and you reveal — the Arkade-Script covenant settles the whole pot to the rightful winner. The winner signs nothing; the loser has no spend path.',
  },
  nofund: {
    kind: 'refund', trigger: 'timeout passes',
    title: 'You refund your stake', detail: 'CLTV self-refund — nothing at risk',
    note: "Because escrows are per-party, the house never touched your stake. If it never funds its own, there's no game — after the timeout you reclaim your stake with just your key. A no-show can't cost you.",
  },
  noreveal: {
    kind: 'forfeit', trigger: 'you revealed → deadline passes',
    title: 'You take the whole pot', detail: 'forfeit path (CLTV) — the staller loses',
    note: "You revealed but the operator won't settle. After the deadline the forfeit leaf lets you sweep BOTH stakes to yourself — stalling costs the house everything.",
  },
}
const outcome = computed(() => OUTCOMES[scenario.value])

const WIN_ODDS: Step[] = [
  { ops: ['OP_2DUP', 'OP_SHA256', '<playerHash>', 'OP_EQUALVERIFY', 'OP_SHA256', '<houseHash>', 'OP_EQUALVERIFY'],
    explain: 'Verify both reveals against their committed hashes — identical to the coin.' },
  { ops: ['OP_SIZE', 'OP_DUP', 'OP_16', 'OP_GREATERTHANOREQUAL', 'OP_SWAP', '22', 'OP_LESSTHAN', 'OP_BOOLAND', 'OP_NOTIF', 'OP_2DROP', 'OP_0', 'OP_ELSE'],
    explain: "Player's length must be in [16, 16+n) — here [16, 22). The length minus 16 is the player's digit in [0, n). Out of range → 0, house wins." },
  { ops: ['OP_SWAP', 'OP_SIZE', 'OP_DUP', 'OP_16', 'OP_GREATERTHANOREQUAL', 'OP_SWAP', '22', 'OP_LESSTHAN', 'OP_BOOLAND', 'OP_NOTIF', 'OP_2DROP', 'OP_1', 'OP_ELSE'],
    explain: "Same range check on the house's secret. House out of range → 1, player wins." },
  { ops: ['OP_SIZE', 'OP_NIP', 'OP_16', 'OP_SUB', 'OP_SWAP', 'OP_SIZE', 'OP_NIP', 'OP_16', 'OP_SUB', 'OP_ADD'],
    explain: 'Decode both digits (digit = length − 16) and add them: sum = digit_house + digit_player, which lands in [0, 2n−2].' },
  { ops: ['OP_DUP', 'OP_6', 'OP_GREATERTHANOREQUAL', 'OP_IF', 'OP_6', 'OP_SUB', 'OP_ENDIF'],
    explain: 'roll = sum mod n. OP_MOD is disabled in Script, but since sum < 2n one conditional subtract does it: if sum ≥ n (6), subtract n.' },
  { ops: ['OP_DUP', 'OP_0', 'OP_GREATERTHANOREQUAL', 'OP_SWAP', 'OP_3', 'OP_LESSTHAN', 'OP_BOOLAND', 'OP_ENDIF', 'OP_ENDIF'],
    explain: 'Player wins iff lo ≤ roll < target — here 0 ≤ roll < 3. Pushes 1 (player) or 0 (house). Win probability = (target − lo) / n.' },
]

// The arkade covenant (covenants.atomicSweep) the emulator runs before signing <emu✦>.
function arkadeSteps(payout: 'player' | 'house'): Step[] {
  const payKey = payout === 'player' ? '<playerPayoutKey>' : '<housePayoutKey>'
  return [
    { ops: ['OP_INSPECTINPUTVALUE', '<otherEscrowStake>', 'OP_EQUALVERIFY'],
      explain: 'Atomicity: the spending tx must also include the OTHER escrow as an input, its value pinned. Neither escrow can be swept on its own.' },
    { ops: ['OP_DUP', 'OP_INSPECTOUTPUTSCRIPTPUBKEY', 'OP_1', 'OP_EQUALVERIFY', payKey, 'OP_EQUALVERIFY'],
      explain: "Destination is forced: output #1's scriptPubKey must be exactly the winner's payout key (P2TR)." },
    { ops: ['OP_INSPECTOUTPUTVALUE', '<fullPot>', 'OP_EQUAL'],
      explain: 'Amount is forced: that output must carry the full pot. The emulator co-signs <emu✦> only if all three checks pass.' },
  ]
}

const COND: string[] = ['‹win condition›']
const winStep = (negate = false): Step => ({
  ops: negate ? [...COND, 'OP_NOT', VERIFY] : [...COND, VERIFY],
  explain: negate
    ? 'Evaluate the win condition and negate it — require the HOUSE won.'
    : 'Evaluate the win condition — require the PLAYER won (true).',
})
const cltvStep: Step = {
  ops: ['<finalExpiration>', 'OP_CHECKLOCKTIMEVERIFY', 'OP_DROP'],
  explain: 'Absolute timelock: this path is unspendable until finalExpiration.',
}
const csvStep: Step = {
  ops: ['<exitDelay>', 'OP_CHECKSEQUENCEVERIFY', 'OP_DROP'],
  explain: 'Relative timelock (CSV): spendable alone after exitDelay — survives an operator outage.',
}

const LEAVES: Leaf[] = [
  {
    key: 'playerWinCovenant', name: 'playerWinCovenant', group: 'collab', cls: 'text-green',
    kind: 'ConditionMultisig[server, emu✦]',
    desc: 'Player won → the operator settles the full pot to the player. The player signs nothing.',
    payout: 'player',
    steps: [winStep(false),
      { ops: ['<serverKey>', 'OP_CHECKSIGVERIFY', '<emu✦>', 'OP_CHECKSIG'],
        explain: '2-of-2: the operator signs, and <emu✦> is the emulator key tweaked by this leaf’s arkade covenant — signed only after the covenant (below) passes. So the pot can only land where the covenant says.' }],
  },
  {
    key: 'creatorWinCovenant', name: 'creatorWinCovenant', group: 'collab', cls: 'text-green',
    kind: 'ConditionMultisig[server, emu✦]',
    desc: 'House won (win condition negated) → the pot settles to the house.',
    payout: 'house',
    steps: [winStep(true),
      { ops: ['<serverKey>', 'OP_CHECKSIGVERIFY', '<emu✦>', 'OP_CHECKSIG'],
        explain: '2-of-2 [operator, emu✦]: same covenant binding, paying the house key.' }],
  },
  {
    key: 'playerForfeit', name: 'playerForfeit', group: 'collab', cls: 'text-gold',
    kind: 'CLTVMultisig[player, server, emu✦]',
    desc: 'If the operator stalls after you revealed, you sweep the entire pot after the deadline.',
    payout: 'player',
    steps: [cltvStep,
      { ops: ['<playerKey>', 'OP_CHECKSIGVERIFY', '<serverKey>', 'OP_CHECKSIGVERIFY', '<emu✦>', 'OP_CHECKSIG'],
        explain: '3-of-3 [player, operator, emu✦]: after the deadline the player sweeps the full pot — the covenant forces the payout to the player. This is the penalty for a stalling house.' }],
  },
  {
    key: 'refund', name: 'refund', group: 'collab', cls: 'text-blue',
    kind: 'CLTVMultisig[funder, server]',
    desc: 'If the game never resolved, each funder reclaims their own stake after the deadline.',
    steps: [cltvStep,
      { ops: ['<funderKey>', 'OP_CHECKSIGVERIFY', '<serverKey>', 'OP_CHECKSIG'],
        explain: '2-of-2 [funder, operator]: the funder reclaims only their own stake — no covenant, no payout binding. No winner, no loss.' }],
  },
  {
    key: 'playerWinExit', name: 'playerWinExit', group: 'exit', cls: '',
    kind: 'ConditionCSVMultisig[player, emu✦]',
    desc: 'The player-win payout, spendable alone after a CSV delay — survives an operator outage.',
    payout: 'player',
    steps: [winStep(false), csvStep,
      { ops: ['<playerKey>', 'OP_CHECKSIGVERIFY', '<emu✦>', 'OP_CHECKSIG'],
        explain: '2-of-2 [player, emu✦]: no operator signature needed; the emulator still enforces the covenant payout.' }],
  },
  {
    key: 'creatorWinExit', name: 'creatorWinExit', group: 'exit', cls: '',
    kind: 'ConditionCSVMultisig[creator, emu✦]',
    desc: 'The house win path, as a self-spendable CSV mirror.',
    payout: 'house',
    steps: [winStep(true), csvStep,
      { ops: ['<houseKey>', 'OP_CHECKSIGVERIFY', '<emu✦>', 'OP_CHECKSIG'],
        explain: '2-of-2 [house, emu✦]: the house exits its win without the operator.' }],
  },
  {
    key: 'playerForfeitExit', name: 'playerForfeitExit', group: 'exit', cls: '',
    kind: 'ConditionCSVMultisig[player, emu✦]',
    desc: 'The forfeit sweep as a CSV mirror, gated by a hash-check on your revealed secret.',
    payout: 'player',
    steps: [
      { ops: ['OP_SHA256', '<playerHash>', 'OP_EQUAL', VERIFY],
        explain: 'Hash-lock: prove you know the secret behind your commitment (you revealed).' },
      csvStep,
      { ops: ['<playerKey>', 'OP_CHECKSIGVERIFY', '<emu✦>', 'OP_CHECKSIG'],
        explain: '2-of-2 [player, emu✦]: sweep the pot to the player without the operator.' }],
  },
  {
    key: 'refundExit', name: 'refundExit', group: 'exit', cls: 'text-blue',
    kind: 'CSVMultisig[funder]',
    desc: 'Last resort — no operator, no emulator. The funder reclaims their stake after the CSV delay.',
    steps: [csvStep,
      { ops: ['<funderKey>', 'OP_CHECKSIG'],
        explain: 'Just the funder’s signature — no operator, no emulator. The final fallback if everything else is down.' }],
  },
]

const collabLeaves = computed(() => LEAVES.filter((l) => l.group === 'collab'))
const exitLeaves = computed(() => LEAVES.filter((l) => l.group === 'exit'))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "back-link"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("« back to play", -1)
        ]))]),
        _: 1
      }),
      _cache[55] || (_cache[55] = _createElementVNode("header", { class: "hiw-header" }, [
        _createElementVNode("h1", null, "How It Works"),
        _createElementVNode("p", { class: "lede" }, [
          _createTextVNode(" A "),
          _createElementVNode("strong", { class: "text-gold" }, "trustless"),
          _createTextVNode(" coinflip: the fairness and the payout are enforced by "),
          _createElementVNode("strong", null, "Bitcoin script"),
          _createTextVNode(" and an "),
          _createElementVNode("strong", null, "Arkade Script"),
          _createTextVNode(" covenant — not by trusting the operator. Everything below is taken directly from this repo's code; expand any spend path to see its exact opcodes, step by step. ")
        ])
      ], -1)),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "tldr-title" }, "The 30-second version", -1)),
          _createElementVNode("ol", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("li", null, [
              _createTextVNode("Both sides "),
              _createElementVNode("strong", null, "commit"),
              _createTextVNode(" to a hidden secret (only its hash is shared).")
            ], -1)),
            (activeVersion.value === 'v4')
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Both sides ", -1),
                  _createElementVNode("strong", null, "co-fund", -1),
                  _createTextVNode(" a single joint pot in one atomic transaction — neither stake moves unless both sign.", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("li", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Each side ", -1),
                  _createElementVNode("strong", null, "escrows", -1),
                  _createTextVNode(" its own stake into its ", -1),
                  _createElementVNode("strong", null, "own", -1),
                  _createTextVNode(" per-party escrow — neither can touch the other's.", -1)
                ]))])),
            _cache[5] || (_cache[5] = _createElementVNode("li", null, [
              _createTextVNode("You "),
              _createElementVNode("strong", null, "reveal"),
              _createTextVNode(" your secret. The two secrets together decide the winner.")
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("li", null, [
              _createTextVNode("An "),
              _createElementVNode("strong", null, "Arkade Script covenant"),
              _createTextVNode(" pays the full pot to the winner — the winner never signs, and the loser has no spend path.")
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("li", null, [
              _createTextVNode("If the operator goes silent, the contract still lets you "),
              _createElementVNode("strong", null, "reclaim or sweep"),
              _createTextVNode(" on your own.")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[9] || (_cache[9] = _createTextVNode("showing ", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(['evol-pill', `evol-${evolution.value}`])
            }, _toDisplayString(EVOLUTION_BY[evolution.value].version), 3),
            _cache[10] || (_cache[10] = _createTextVNode(" model", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scenarios, (s) => {
              return _createElementVNode("button", {
                key: s.id,
                type: "button",
                role: "tab",
                "aria-selected": scenario.value === s.id,
                class: _normalizeClass(['scenario-tab', { active: scenario.value === s.id }]),
                onClick: ($event: any) => (scenario.value = s.id)
              }, _toDisplayString(s.label), 11, _hoisted_11)
            }), 64))
          ]),
          (evolution.value === 'v1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pp-col" }, [
                    _createElementVNode("div", { class: "pp-box you" }, [
                      _createElementVNode("span", { class: "pp-name" }, "YOU"),
                      _createElementVNode("span", { class: "pp-meta" }, "commit + stake")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["pp-box house", { ghost: scenario.value === 'nofund' }])
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "pp-name" }, "HOUSE", -1)),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(scenario.value === 'nofund' ? 'no-show' : 'commit + stake'), 1)
                    ], 2)
                  ])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "pp-merge" }, "↓ setup tx ↓", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["pp-box escrow shared", scenario.value === 'nofund' ? 'empty' : 'filled'])
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "pp-name" }, "shared escrow", -1)),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(scenario.value === 'nofund' ? 'half-funded · stranded risk' : 'both stakes pooled'), 1)
                ], 2),
                _createElementVNode("div", _hoisted_17, _toDisplayString(outcome.value.trigger), 1),
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "pp-merge" }, "↓ final tx ↓", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["pp-outcome", outcome.value.kind])
                }, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(outcome.value.title), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(outcome.value.detail), 1)
                ], 2)
              ]))
            : (evolution.value === 'v4')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pp-col" }, [
                      _createElementVNode("div", { class: "pp-box you" }, [
                        _createElementVNode("span", { class: "pp-name" }, "YOU"),
                        _createElementVNode("span", { class: "pp-meta" }, "digit + salt commit")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pp-box house", { ghost: scenario.value === 'nofund' }])
                      }, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "pp-name" }, "HOUSE", -1)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(scenario.value === 'nofund' ? 'no-show' : 'digit + salt commit'), 1)
                      ], 2)
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "pp-merge" }, "↓ atomic co-fund · 1 tx ↓", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["pp-box escrow shared", scenario.value === 'nofund' ? 'empty' : 'filled'])
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "pp-name" }, "joint pot", -1)),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(scenario.value === 'nofund' ? 'co-fund never lands' : 'both stakes · one VTXO'), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_25, [
                    _createTextVNode(_toDisplayString(scenario.value === 'nofund' ? 'co-fund aborts atomically' : outcome.value.trigger) + " ", 1),
                    (scenario.value === 'happy')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "payTo(winner, pot) · 1 settle tx"))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "pp-merge" }, "↓ settle · 1 tx ↓", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["pp-outcome", scenario.value === 'nofund' ? 'refund' : outcome.value.kind])
                  }, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(scenario.value === 'nofund' ? 'Nothing at risk' : outcome.value.title), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(scenario.value === 'nofund' ? 'atomic co-fund — both sign or it never lands' : outcome.value.detail), 1)
                  ], 2)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "pp-name" }, "YOU", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(evolution.value === 'v3' ? 'digit + salt commit' : 'commit + stake'), 1)
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "pp-arr" }, "↓", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "pp-box escrow filled" }, [
                        _createElementVNode("span", { class: "pp-name" }, "your escrow"),
                        _createElementVNode("span", { class: "pp-meta" }, "staked")
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pp-box house", { ghost: scenario.value === 'nofund' }])
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "pp-name" }, "HOUSE", -1)),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(scenario.value === 'nofund' ? 'no-show' : (evolution.value === 'v3' ? 'digit + salt commit' : 'commit + stake')), 1)
                      ], 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(["pp-arr", { ghost: scenario.value === 'nofund' }])
                      }, "↓", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["pp-box escrow", scenario.value === 'nofund' ? 'empty' : 'filled'])
                      }, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "pp-name" }, "house escrow", -1)),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(scenario.value === 'nofund' ? 'never funded' : 'staked'), 1)
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createTextVNode(_toDisplayString(outcome.value.trigger) + " ", 1),
                    (evolution.value === 'v3' && scenario.value === 'happy')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "via OP_INSPECTPACKET arkade-script"))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "pp-merge" }, "↓", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["pp-outcome", outcome.value.kind])
                  }, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(outcome.value.title), 1),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(outcome.value.detail), 1)
                  ], 2)
                ])),
          (!(evolution.value === 'v4' && scenario.value === 'nofund'))
            ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(outcome.value.note), 1))
            : _createCommentVNode("", true),
          (evolution.value === 'v4' && scenario.value === 'nofund')
            ? (_openBlock(), _createElementBlock("p", _hoisted_42, " v0.4: the co-fund is a single atomic tx — if the house never signs, it simply never lands, so neither stake is ever committed. Nothing to refund, nothing to strand. "))
            : _createCommentVNode("", true),
          (evolution.value === 'v1' && scenario.value === 'nofund')
            ? (_openBlock(), _createElementBlock("p", _hoisted_43, " ⚠ v0.1 limitation: a no-show on the shared escrow could strand your stake until either side cooperated. Per-party escrows in v0.2/v0.3 fix this — each side reclaims its OWN stake unilaterally after the timeout. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_44, [
        _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Design evolution", -1)),
        _createElementVNode("p", _hoisted_45, [
          _cache[27] || (_cache[27] = _createTextVNode(" The contract has gone through three shipped designs, plus a fourth (", -1)),
          _cache[28] || (_cache[28] = _createElementVNode("strong", null, "v0.4", -1)),
          _cache[29] || (_cache[29] = _createTextVNode(", the joint pot). This client is playing ", -1)),
          _createElementVNode("strong", null, _toDisplayString(activeVersion.value === 'v4' ? 'v0.4 (joint pot)' : 'v0.3 (per-party escrow)'), 1),
          _cache[30] || (_cache[30] = _createTextVNode(" right now — read from ", -1)),
          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "mono" }, "/api/network", -1)),
          _cache[32] || (_cache[32] = _createTextVNode(" — and the tabs below open on it. The other variants are kept for reference; each one fixes a real flaw in the previous. The detailed spend-path and flow sections further down describe the ", -1)),
          _cache[33] || (_cache[33] = _createElementVNode("strong", null, "v0.3", -1)),
          _cache[34] || (_cache[34] = _createTextVNode(" per-party-escrow design, the shape v0.4 streamlines into a single co-funded pot. ", -1))
        ]),
        _createElementVNode("div", _hoisted_46, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(EVOLUTION, (e) => {
            return _createElementVNode("button", {
              key: e.id,
              type: "button",
              role: "tab",
              "aria-selected": evolution.value === e.id,
              class: _normalizeClass(['variant-tab', { active: evolution.value === e.id }]),
              onClick: ($event: any) => (evolution.value = e.id)
            }, _toDisplayString(e.tab), 11, _hoisted_47)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("span", _hoisted_50, _toDisplayString(EVOLUTION_BY[evolution.value].version), 1),
            _createElementVNode("span", _hoisted_51, _toDisplayString(EVOLUTION_BY[evolution.value].title), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["evolution-badge", EVOLUTION_BY[evolution.value].badge.cls])
            }, _toDisplayString(EVOLUTION_BY[evolution.value].badge.label), 3)
          ]),
          _createElementVNode("p", _hoisted_52, _toDisplayString(EVOLUTION_BY[evolution.value].summary), 1),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "evolution-h" }, "How it worked", -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(EVOLUTION_BY[evolution.value].how, (b, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `how-${i}`
                  }, _toDisplayString(b), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("h4", _hoisted_56, _toDisplayString(EVOLUTION_BY[evolution.value].whyTitle || 'Why we moved on'), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(EVOLUTION_BY[evolution.value].why, (b, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `why-${i}`
                  }, _toDisplayString(b), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _cache[56] || (_cache[56] = _createStaticVNode("<section class=\"hiw-section\" data-v-753debfd><h2 data-v-753debfd>The building blocks</h2><div class=\"layer-grid\" data-v-753debfd><article class=\"layer-card\" data-v-753debfd><div class=\"layer-badge arkade\" data-v-753debfd>ARKADE</div><h3 data-v-753debfd>Arkade — the execution layer</h3><p data-v-753debfd> Arkade is a <strong data-v-753debfd>programmable Bitcoin execution layer</strong>. Coins are held as <strong data-v-753debfd>VTXOs</strong> (Virtual Transaction Outputs) — self-custodial, off-chain Bitcoin coins that move <strong data-v-753debfd>instantly at near-zero fees</strong>, with no changes to Bitcoin required. The coinflip stakes are VTXOs. </p><p data-v-753debfd> Two of its properties make this game possible: a VTXO can be locked by <strong data-v-753debfd>any valid Tapscript</strong> (so the escrow&#39;s spend paths below are enforceable), and you keep <strong data-v-753debfd>unilateral exit</strong> — funds are always withdrawable on-chain without the operator&#39;s cooperation. More at <a href=\"https://docs.arkadeos.com\" target=\"_blank\" rel=\"noopener\" data-v-753debfd>docs.arkadeos.com</a>. </p></article><article class=\"layer-card\" data-v-753debfd><div class=\"layer-badge script\" data-v-753debfd>ARKADE SCRIPT</div><h3 data-v-753debfd>Arkade Script — the covenant</h3><p data-v-753debfd> Plain Bitcoin script can&#39;t say <em data-v-753debfd>&quot;this may only be spent to address X for exactly amount Y.&quot;</em> That rule — a <strong data-v-753debfd>covenant</strong> — is what makes the trustless payout possible. </p><p data-v-753debfd> In the code it works through an <strong data-v-753debfd>emulator</strong> co-signer. A covenant leaf is an ordinary multisig whose emulator pubkey is <em data-v-753debfd>tweaked</em> by <span class=\"mono\" data-v-753debfd>pubkey + tagged_hash(&quot;ArkScriptHash&quot;, arkadeScript)·G</span>. The emulator produces that tweaked signature <strong data-v-753debfd>only after running the arkade script</strong> — so a signature on the <span class=\"mono\" data-v-753debfd>&lt;emu✦&gt;</span> slot <em data-v-753debfd>is</em> the proof the covenant held. The script bytes travel at spend time in the <span class=\"mono\" data-v-753debfd>EmulatorPacket</span>. </p></article></div></section><section class=\"hiw-section\" data-v-753debfd><h2 data-v-753debfd>The commit–reveal coin</h2><p class=\"section-intro\" data-v-753debfd> The randomness comes from two secrets neither side can see in advance. The trick: the <strong data-v-753debfd>length</strong> of the secret encodes the choice. </p><div class=\"cr-grid\" data-v-753debfd><div class=\"cr-card\" data-v-753debfd><div class=\"cr-step\" data-v-753debfd>1 · Commit</div><p data-v-753debfd>Each side shares only the <strong data-v-753debfd>SHA-256 hash</strong> of a random secret — hiding both the bytes and the length, so neither can react to the other&#39;s choice.</p></div><div class=\"cr-card\" data-v-753debfd><div class=\"cr-step\" data-v-753debfd>2 · Encode</div><p data-v-753debfd>Coin: <span class=\"chip\" data-v-753debfd>15 bytes = Heads</span> <span class=\"chip\" data-v-753debfd>16 bytes = Tails</span>. Variable-odds: length is <span class=\"mono\" data-v-753debfd>16 + digit</span>, <span class=\"mono\" data-v-753debfd>digit ∈ [0, n)</span>.</p></div><div class=\"cr-card\" data-v-753debfd><div class=\"cr-step\" data-v-753debfd>3 · Reveal</div><p data-v-753debfd>Coin: you win when your secret&#39;s length <strong data-v-753debfd>matches</strong> the house&#39;s. Odds: <span class=\"mono\" data-v-753debfd>roll = (d_house + d_player) mod n</span>; you win when <span class=\"mono\" data-v-753debfd>lo ≤ roll &lt; target</span>.</p></div></div><p class=\"note\" data-v-753debfd><span class=\"note-tag\" data-v-753debfd>Fair RNG</span> The coin side and the odds digit are drawn from a <strong data-v-753debfd>CSPRNG</strong>; the committed hash binds each side to its choice <em data-v-753debfd>before</em> any reveal. The <span class=\"mono\" data-v-753debfd>‹win condition›</span> tapscript below verifies exactly this on-chain. </p></section>", 2)),
      _createElementVNode("section", _hoisted_57, [
        _cache[49] || (_cache[49] = _createElementVNode("h2", null, "The escrow contract — 8 spend paths", -1)),
        _cache[50] || (_cache[50] = _createElementVNode("p", { class: "section-intro" }, [
          _createTextVNode(" Stakes go into a Taproot contract ("),
          _createElementVNode("span", { class: "mono" }, "CoinflipEscrowScript"),
          _createTextVNode("). It's "),
          _createElementVNode("strong", null, "per-party"),
          _createTextVNode(" — house funds the house escrow, you fund the player escrow — so neither side can abort and steal the other's stake. Each escrow has eight tapscript leaves: four "),
          _createElementVNode("strong", null, "collaborative"),
          _createTextVNode(" covenant paths and four "),
          _createElementVNode("strong", null, "unilateral exit"),
          _createTextVNode(" mirrors. Click "),
          _createElementVNode("span", { class: "mono" }, "show script ▸"),
          _createTextVNode(" on any leaf for its opcodes, explained step by step. ")
        ], -1)),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("button", {
            class: "sub-toggle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle('cond')))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["caret", { open: open.value.cond }])
            }, "▸", 2),
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "mono" }, "‹win condition›", -1)),
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "sub-hint" }, "the on-chain script that decides the winner", -1))
          ]),
          (open.value.cond)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _cache[39] || (_cache[39] = _createElementVNode("p", { class: "variant-note" }, [
                  _createTextVNode(" Example shown: "),
                  _createElementVNode("span", { class: "mono" }, "n = 6, lo = 0, target = 3"),
                  _createTextVNode(" — a \"roll under 3 on a d6\" bet (player wins ~50%). Every skin just changes "),
                  _createElementVNode("span", { class: "mono" }, "n / lo / target"),
                  _createTextVNode(". ")
                ], -1)),
                _createVNode(StepList, { steps: WIN_ODDS }),
                _cache[40] || (_cache[40] = _createStaticVNode("<p class=\"ops-note\" data-v-753debfd>Result: <span class=\"mono\" data-v-753debfd>1</span> → player wins, <span class=\"mono\" data-v-753debfd>0</span> → house wins. <span class=\"mono\" data-v-753debfd>creatorWin*</span> leaves wrap this in <span class=\"mono\" data-v-753debfd>OP_NOT</span>. An invalid secret length <em data-v-753debfd>loses</em> (it can&#39;t void the game).</p>", 1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "leaf-col-head collab" }, "Collaborative (operator + emulator)", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collabLeaves.value, (leaf) => {
              return (_openBlock(), _createElementBlock("div", {
                key: leaf.key,
                class: "leaf"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["leaf-name", leaf.cls])
                }, _toDisplayString(leaf.name), 3),
                _createElementVNode("div", _hoisted_62, _toDisplayString(leaf.kind), 1),
                _createElementVNode("p", null, _toDisplayString(leaf.desc), 1),
                _createElementVNode("button", {
                  class: "show-script",
                  onClick: ($event: any) => (toggle(leaf.key))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["caret", { open: open.value[leaf.key] }])
                  }, "▸", 2),
                  _cache[41] || (_cache[41] = _createTextVNode(" show script ", -1))
                ], 8, _hoisted_63),
                (open.value[leaf.key])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "script-label" }, "Tapscript — spend path", -1)),
                      _createVNode(StepList, {
                        steps: leaf.steps
                      }, null, 8, ["steps"]),
                      (leaf.payout)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "script-label arkade-label" }, [
                              _createTextVNode("Arkade covenant — run by the emulator for "),
                              _createElementVNode("span", { class: "mono" }, "<emu✦>")
                            ], -1)),
                            _createVNode(StepList, {
                              steps: arkadeSteps(leaf.payout)
                            }, null, 8, ["steps"])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_65, [
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "leaf-col-head exit" }, "Unilateral exit (no operator needed)", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exitLeaves.value, (leaf) => {
              return (_openBlock(), _createElementBlock("div", {
                key: leaf.key,
                class: "leaf"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["leaf-name", leaf.cls])
                }, _toDisplayString(leaf.name), 3),
                _createElementVNode("div", _hoisted_66, _toDisplayString(leaf.kind), 1),
                _createElementVNode("p", null, _toDisplayString(leaf.desc), 1),
                _createElementVNode("button", {
                  class: "show-script",
                  onClick: ($event: any) => (toggle(leaf.key))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["caret", { open: open.value[leaf.key] }])
                  }, "▸", 2),
                  _cache[45] || (_cache[45] = _createTextVNode(" show script ", -1))
                ], 8, _hoisted_67),
                (open.value[leaf.key])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "script-label" }, "Tapscript — spend path", -1)),
                      _createVNode(StepList, {
                        steps: leaf.steps
                      }, null, 8, ["steps"]),
                      (leaf.payout)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "script-label arkade-label" }, [
                              _createTextVNode("Arkade covenant — run by the emulator for "),
                              _createElementVNode("span", { class: "mono" }, "<emu✦>")
                            ], -1)),
                            _createVNode(StepList, {
                              steps: arkadeSteps(leaf.payout)
                            }, null, 8, ["steps"])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _cache[51] || (_cache[51] = _createElementVNode("p", { class: "legend mono" }, [
          _createElementVNode("span", { class: "tok tok-var" }, "<emu✦>"),
          _createTextVNode(" emulator key tweaked by that leaf's arkade script · "),
          _createElementVNode("span", { class: "tok tok-arkade" }, "OP_INSPECT…"),
          _createTextVNode(" Arkade-extension opcodes (tx introspection) · ‹win condition› expands above ")
        ], -1))
      ]),
      _createElementVNode("section", _hoisted_69, [
        _createElementVNode("h2", null, [
          _cache[52] || (_cache[52] = _createTextVNode("A game, end to end ", -1)),
          _createElementVNode("span", _hoisted_70, [
            _createElementVNode("span", {
              class: _normalizeClass(['evol-pill', `evol-${evolution.value}`])
            }, _toDisplayString(EVOLUTION_BY[evolution.value].version), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(FLOW_STEPS[evolution.value], (step) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step.num,
              class: _normalizeClass(["flow-step", step.cls])
            }, [
              _createElementVNode("div", _hoisted_72, _toDisplayString(step.num), 1),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("h4", null, _toDisplayString(step.title), 1),
                _createElementVNode("p", {
                  innerHTML: step.body
                }, null, 8, _hoisted_74)
              ])
            ], 2))
          }), 128))
        ])
      ]),
      _cache[57] || (_cache[57] = _createStaticVNode("<section class=\"hiw-section trust\" data-v-753debfd><h2 data-v-753debfd>What you have to trust</h2><ul class=\"trust-list\" data-v-753debfd><li data-v-753debfd><span class=\"tick\" data-v-753debfd>✓</span><span class=\"t\" data-v-753debfd><strong data-v-753debfd>Not the outcome.</strong> It&#39;s fixed by the committed hashes before any reveal.</span></li><li data-v-753debfd><span class=\"tick\" data-v-753debfd>✓</span><span class=\"t\" data-v-753debfd><strong data-v-753debfd>Not the payout.</strong> The covenant only authorizes the full pot to the rightful winner&#39;s key; the loser has no spendable leaf.</span></li><li data-v-753debfd><span class=\"tick\" data-v-753debfd>✓</span><span class=\"t\" data-v-753debfd><strong data-v-753debfd>Not the operator&#39;s uptime.</strong> The forfeit, refund, and exit leaves recover your funds without it.</span></li><li data-v-753debfd><span class=\"cross\" data-v-753debfd>·</span><span class=\"t\" data-v-753debfd><strong data-v-753debfd>You do rely on</strong> the emulator running the published arkade script honestly for the <em data-v-753debfd>fast</em> path — and on Arkade itself (<a href=\"https://docs.arkadeos.com\" target=\"_blank\" rel=\"noopener\" data-v-753debfd>docs</a>). If the emulator misbehaves or vanishes, <span class=\"mono\" data-v-753debfd>refundExit</span> still returns your stake with no operator and no emulator.</span></li></ul></section>", 1)),
      _createElementVNode("footer", _hoisted_75, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "btn-gold"
        }, {
          default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
            _createTextVNode("Start playing", -1)
          ]))]),
          _: 1
        }),
        _cache[54] || (_cache[54] = _createElementVNode("span", { class: "footer-cite text-muted" }, [
          _createTextVNode("Secret-length coin scheme inspired by "),
          _createElementVNode("a", {
            href: "https://arxiv.org/pdf/1612.05390v3",
            target: "_blank",
            rel: "noopener"
          }, "arxiv.org/pdf/1612.05390v3")
        ], -1))
      ])
    ])
  ]))
}
}

})